
import styles from './index.module.scss'
import GoBack from "../components/GoBack"
import { useState, useContext, useMemo, useEffect, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { EditOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils';
import API from "@api/api";
import usePickedImageList from './usePickedImageList';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PictureViewModal from '../components/PictureViewModal'
import { DISPLAY_TYPE } from '@utils/CONST'
import usePickedImageDownload from './usePickedImageDownload'
import { BatchImagesContext } from '../BatchImagesContext'

const ResultsPage = (props) => {
    const navigate = useNavigate()
    const { setSelectSkuId } = useContext(BatchImagesContext)
    const { projectId } = useParams()
    const [skuList, setSkuList] = useState([])
    const [projectName, setProjectName] = useState('')

    useEffect(() => {
        if (!projectId) return
        batchListSkuCoverList()
    }, [projectId])

    // 生成页面左侧SKU列表
    const batchListSkuCoverList = () => {
        API.batchListSkuCoverList({
            projectId: projectId
        }).then(res => {
            if (res.code === 0) {
                const newSkuList = res.data?.skuDetailList || []
                setSkuList(newSkuList || [])
                setActiveSku(newSkuList?.[0]?.skuId || '')
                setProjectName(res.data?.projectName || '')
            } else if (res?.code == -5003) {
                navigate("/home/product/batchImages")
                message.error(res.message)
            }
        })
    }

    // 取选图列表
    const { pickedList, groupedPickedList, pickedCount, refreshPickedList } = usePickedImageList(projectId, projectName)

    // 下载选中图
    const { handleDownload, downLoading } = usePickedImageDownload(projectId)


    // ============= 🔹 核心逻辑：滚动绑定 =============
    const groupRefs = useRef({}) // 保存右侧每个 skuId 对应的 div
    const rightBoxRef = useRef(null)
    const [activeSku, setActiveSku] = useState(null)

    const handleScrollToSku = (skuId) => {
        setActiveSku(skuId);
        const rightBox = rightBoxRef.current;
        const target = groupRefs.current[skuId];
        if (rightBox && target) {
            const offsetTop = target.offsetTop - rightBox.offsetTop;

            rightBox.scrollTo({
                top: offsetTop,
                behavior: "smooth",
            });
        }
    }

    // 大图弹窗
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [item, setItem] = useState()
    const [taskId, setTaskId] = useState()
    const [modalOpenFlag, setModalOpenFlag] = useState(false)
    const modalRef = useRef(null)
    useEffect(() => {
        if (!isModalOpen) {
            setTaskId()
            setItem()
        }
    }, [isModalOpen])
    const handleCLick = (item) => {
        if (item.status != "succeeded") return
        setItem(item)
        setTaskId(item?.taskId)
    }
    useEffect(() => {
        if (item && taskId) {
            setIsModalOpen(true)
        }
    }, [item, taskId])

    const goSelect = (skuId) => {
        setSelectSkuId(skuId)
        navigate(`/home/product/${projectId}/detail`)
    }

    return (
        <>
            <div className={styles.SelectedPage}>
                <div className={styles.ResultsPageWrap}>
                    <div className={styles.GoBack}>
                        <GoBack onClick={() => navigate(`/home/product/${projectId}/detail`)} />
                        <span className={styles.TaskTitle}>查看已选图</span>
                    </div>
                    <div className={styles.ResultsBox}>
                        <div className={`${styles.ResultsBoxLeft} _beauty_scrollbar`}>
                            {skuList?.map((item) => (
                                <div
                                    key={item.skuId}
                                    className={`${styles.ImageItem} ${activeSku === item.skuId ? styles.active : ""}`}
                                    onClick={() => handleScrollToSku(item.skuId)}
                                >
                                    <img src={Utils.getImgThumbnail(item.cover)} alt="" />
                                </div>
                            ))}
                        </div>
                        <div ref={rightBoxRef} className={`${styles.ResultsBoxRight} _beauty_scrollbar`}>
                            {
                                groupedPickedList?.map((item, index) => (
                                    item?.[0]?.picked ? <div ref={(el) => groupRefs.current[item?.[0]?.skuId] = el} className={styles.groupWrap} key={item?.[0]?.skuId}>
                                        <p>商品ID：{item?.[0]?.taskSerial}（已选择{item?.length}张）</p>
                                        {
                                            item?.map((imgItem, imgIndex) => (
                                                <div className={styles.groupWrapItemImg} onClick={() => handleCLick(imgItem)} key={imgItem?.taskId}>
                                                    <LazyLoadImage
                                                        alt="example"
                                                        effect="blur"
                                                        src={imgItem?.results?.[0]?.image}
                                                        placeholderSrc={Utils.getImgThumbnail(imgItem?.results?.[0]?.image)}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div> : <div ref={(el) => groupRefs.current[item?.[0]?.skuId] = el} className={styles.groupWrap} key={item?.[0]?.skuId}>
                                        <p>商品待选：{item?.[0]?.taskSerial}（已选择0张）</p>
                                        <div className={styles.groupWrapItemImgNull}>
                                            <div style={{ width: '100%' }}>
                                                <Iconfont className={styles.Icon} type="icon-newProjectOutlined" />
                                                <Button className={styles.GoSelectBtn} onClick={() => goSelect(item?.[0]?.skuId)}>去选图</Button>
                                            </div>
                                        </div>
                                    </div>

                                ))
                            }
                            <Button type="primary"
                                loading={downLoading}
                                disabled={downLoading}
                                className={styles.ViewSelectedBtn}
                                onClick={() => handleDownload()}>下载全部已选图（{pickedCount}张）</Button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                footer={null}
                maskClosable={true}
                width={1600}
                destroyOnHidden
                onCancel={() => setIsModalOpen(false)}
                className={styles.PictureViewModal}
                afterOpenChange={(open) => setModalOpenFlag(open)}
                closeIcon={<span
                    onClick={() => setIsModalOpen(false)}
                    className={styles.modalcloseIcon}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        position: 'absolute',
                        top: '-40px',
                        right: '-40px',
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0,0,0,0.24)',
                        boxShadow: 'none',
                    }}>
                    <CloseOutlined /></span>}
            >
                <PictureViewModal
                    modalOpenFlag={modalOpenFlag}
                    isSelectPage={true} //是否是调图页
                    displayType={DISPLAY_TYPE.PROJECT}
                    setProjectId={() => null}
                    ref={modalRef}
                    taskId={taskId}
                    setTaskId={setTaskId}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    item={item}
                    setItem={setItem}
                    groupedTasks={groupedPickedList}
                    fetchProjectDetail={refreshPickedList} />
            </Modal>
        </>

    )
}

export default ResultsPage